<div mat-dialog-title>QR-Code scannen</div>
<zxing-scanner [formats]="allowedQrFormats"
               (scanSuccess)="scanSuccessHandler($event)"></zxing-scanner>
